import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import type PlanModel from './plan.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class TierModel extends Model {
  @attr declare fromCycle: number;
  @attr declare amount: number;
  @attr declare per: string;
  @attr declare percentage: number;
  @attr declare maximum: number | null;
  @attr declare overrideAmount: string;
  @attr declare overridePercentage: string;
  @attr declare createdAt: string;
  @attr declare updatedAt: string;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('plan', { async: false, inverse: 'tiers' })
  declare plan: PlanModel;

  /*************************
   **  Computed           **
   *************************/

  /**
   * Amount in dollars (stored as cents in DB)
   */
  get amountInDollars(): number {
    return (this.amount || 0) / 100;
  }

  [Type] = 'tier' as const;
}
